import 'ckeditor5.css';
import React, { useEffect, useState } from 'react';
import Divider from '@mui/material/Divider';
import { Col, Row } from 'react-bootstrap';
import Button from '@mui/material/Button';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Paper from '@mui/material/Paper';
import { useForm } from 'react-hook-form';
import Alert, { useAlert } from 'components/snacks/Alert';
import { getBase64 } from 'utils/Base64';
import { postNewTicket, TicketCategory, getServiceList } from 'api/Api';
import {CKEditor} from '@ckeditor/ckeditor5-react';

import {
  ClassicEditor,
  Alignment,
  AutoLink,
  Autosave,
  Bold,
  Code,
  Essentials,
  Italic,
  Link,
  Paragraph,
  Underline,
  Undo
} from 'ckeditor5';
import { useHistory } from 'react-router-dom';

const AddTicket = () => {
  const {
    register,
    formState: { errors }
  } = useForm();
  const [catData, setCatData] = useState([]);
  const [userServices, setUserServices] = useState([]);
  const [file, setFile] = useState(null);
  const [fileResult, setFileResult] = useState(null);
  const [base64, setBase64] = useState(null);
  const [title, setTitle] = useState('');
  const [subject, setSubject] = useState('1');
  const [message, setMessage] = useState('');
  const [service, setService] = useState('');
  const [isPayment, setIsPayment] = useState(false);
  const alert_timeout = 10000;
  const alertStore = useAlert(alert_timeout);
  const history = useHistory();

  const handleFile = (e) => {
    setFile(e.target.files[0]);
  };

  const getServices = () => {
    getServiceList((isOk, data) => {
      setUserServices(data.services);
    })
  }

  const newTicket = () => {
    if (!title || !subject || !message) {
      alertStore.AddAlert({
        key: 'required',
        message: 'پر کردن فیلدهای ستاره دار الزامی است!',
        severity: 'error',
        auto_hide: true
      });
    } else {
      const formData = new FormData();
      formData.append('title', title);
      formData.append('subject', subject ? parseInt(subject) : 1);
      formData.append('message', message);
      formData.append('ticket_file', file);
      formData.append('service_id', service)
      setIsPayment(true)
      postNewTicket(formData, (isOk, data) => {
        if (!isOk) {
          alertStore.AddAlert({
            key: '400',
            message: 'خطای سرور ...',
            severity: 'error',
            auto_hide: true
          });
          setTimeout(()=>{

            setIsPayment(false)
          }, 1500)
        } else {
          alertStore.AddAlert({
            key: '400',
            message: data.msg,
            severity: 'success',
            auto_hide: true
          });
          history.push("/tickets/ticket-detail", {
            id: data.ticket_id,
            title: data.ticket_title,
            user_id: data.user_id
          });
        }
      });
    }
  };

  useEffect(() => {
    if (file) {
      getBase64(file)
        .then((result) => {
          file['base64'] = result;
          setBase64(result);
          setFileResult(result);
        })
        .catch((err) => {
          console.log(err);
        });
    }

    TicketCategory((isOk, data) => {
      if (!isOk) {
        alertStore.AddAlert({
          key: '400',
          message: data.msg,
          severity: 'error',
          auto_hide: true
        });
      }
      setCatData(data.category);
    });
  }, [file]);

  useEffect(() => {
    getServices()
  }, []);

  const editorConfig = {
    toolbar: {
      items: [
        'undo',
        'redo',
        '|',
        'bold',
        'italic',
        'underline',
        'code',
        '|',
        'link',
        '|',
        'alignment',
      ],
      shouldNotGroupWhenFull: false
    },
    plugins: [
      Undo,
      Alignment,
      AutoLink,
      Autosave,
      Bold,
      Code,
      Essentials,
      Italic,
      Link,
      Paragraph,
      Underline
    ],
    initialData:
        '',
    language: 'fa',
    link: {
      addTargetToExternalLinks: true,
      defaultProtocol: 'https://',
      decorators: {
        toggleDownloadable: {
          mode: 'manual',
          label: 'Downloadable',
          attributes: {
            download: 'file'
          }
        }
      }
    },
    placeholder: 'متن ...'
  };

  return (
    <>
      <Paper elevation={1}>
        <div className="bg-white rounded-25 p-10">
          <h1 className={'f-13'}>ارسال تیکت جدید</h1>
          <Divider className={'mt-3'} style={{ backgroundColor: '#e8e8e8' }} />
          <Row className={'mt-5'}>
            <Col lg={'5'} md={'7'} xs={'12'} className={''}>
              <div
                  className={
                    'd-flex flex-column justify-content-center align-items-start h-100'
                  }
              >
                <label className={'w-100 mb-7'}>
                  <span className={''}>
                    عنوان
                    <span className={'text-danger'}>*</span>
                  </span>
                  <input
                      {...register('title', {required: true})}
                      onChange={(e) => setTitle(e.target.value)}
                      type="text"
                      style={{borderBottom: '2px solid #e7e4e4'}}
                      className="form-control form-control-lg form-control-solid mb-3 mb-lg-0"
                      placeholder=""
                      autoFocus
                  />
                </label>
                <label className={'w-100 mb-7'}>
                  <span className={''}>
                    موضوع
                    <span className={'text-danger'}>*</span>
                  </span>
                  <select
                      {...register('subject', {required: true})}
                      onChange={(e) => setSubject(e.target.value)}
                      value={subject}
                      // defaultValue={1}
                      className={'d-block w-100'}
                      style={{
                        border: 'none',
                        borderBottom: '2px solid #e7e4e4',
                        backgroundColor: '#f5f8fa',
                        color: '#5e6278',
                        transition: 'color .2s ease,background-color .2s ease',
                        minHeight: 'calc(1.5em + 1.65rem + 2px)',
                        padding: '0.825rem 1.5rem',
                        fontSize: '1.1em',
                        borderRadius: '0.475rem'
                      }}
                  >
                    {catData &&
                        catData.map((cat, index) => (
                            <option key={index} value={cat.id}>
                              {cat.title}
                            </option>
                        ))}
                  </select>
                </label>
                <label className={'w-100 mb-7'}>
                  <span className={''}>
                    سرویس
                  </span>
                  <select
                      {...register('subject', {required: false})}
                      onChange={(e) => setService(e.target.value)}
                      value={service}
                      // defaultValue={1}
                      className={'d-block w-100'}
                      style={{
                        border: 'none',
                        borderBottom: '2px solid #e7e4e4',
                        backgroundColor: '#f5f8fa',
                        color: '#5e6278',
                        transition: 'color .2s ease,background-color .2s ease',
                        minHeight: 'calc(1.5em + 1.65rem + 2px)',
                        padding: '0.825rem 1.5rem',
                        fontSize: '1.1em',
                        borderRadius: '0.475rem'
                      }}
                  >
                    <option value="">-</option>
                    {
                      userServices.map((cat, index) => (
                          <option key={index} value={cat.id}>
                            {cat.product_name + ( cat.ip ? ' - ' + cat.ip : '') + (cat.user_label ? ' - ' + cat.user_label : '')}
                          </option>
                      ))
                    }
                  </select>
                </label>
                <label className={'w-100 mb-1'}>
                  <span className={''}>
                    متن پیام
                    <span className={'text-danger'}>*</span>
                  </span>
                  {/*  <textarea*/}
                  {/*    id={'message'}*/}
                  {/*    {...register('message', { required: true })}*/}
                  {/*    className={'d-block w-100'}*/}
                  {/*    aria-label="minimum height"*/}
                  {/*    rows={3}*/}
                  {/*    placeholder="پیام..."*/}
                  {/*    style={{*/}
                  {/*      border: 'none',*/}
                  {/*      borderBottom: '2px solid #e7e4e4',*/}
                  {/*      backgroundColor: '#f5f8fa',*/}
                  {/*      transition: 'color .2s ease,background-color .2s ease',*/}
                  {/*      minHeight: 'calc(1.5em + 1.65rem + 2px)',*/}
                  {/*      padding: '0.825rem 1.5rem',*/}
                  {/*      fontSize: '1.1em',*/}
                  {/*      borderRadius: '0.475rem'*/}
                  {/*    }}*/}
                  {/*    onChange={(e) => setMessage(e.target.value)}*/}
                  {/*  />*/}
                </label>
                <CKEditor
                    editor={ClassicEditor}
                    config={editorConfig}
                    class={"w-100"}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      setMessage(data);
                    }}
                />
                <label
                    style={{
                      borderBottom: '2px solid #e7e4e4',
                      cursor: 'pointer'
                    }}
                    className="form-control form-control-lg form-control-solid mb-3 w-100 my-7"
                >
                  <CloudUploadIcon color={'action'}/>
                  {file ? (
                      <span className={'ps-4'}>{file.name}</span>
                  ) : (
                      <span className={'ps-4'}> انتخاب فایل </span>
                  )}

                  <input
                      {...register('ticket_file')}
                      type={'file'}
                      onChange={(e) => setFile(e.target.files[0])}
                      accept={'image/*,.pdf'}
                      hidden
                  />
                </label>
                <Button
                    color={'primary'}
                    variant={'contained'}
                    className={'f-09 yekan-font'}
                    onClick={newTicket}
                    disabled={isPayment}
                >
                  ثبت تیکت
                </Button>
              </div>
            </Col>
            <Col lg={'7'} className={'d-lg-block d-none'}>
              <div
                  className={'d-flex justify-content-center align-items-center'}
              >
                <img
                    src={'./../../assets/media/illustrations/sketchy-1/20.png'}
                    width={'60%'}
                />
              </div>
            </Col>
          </Row>
        </div>
      </Paper>
      {
        <Alert
            alerts={alertStore.alert}
            close={alertStore.RemoveAlert}
            timeout={alert_timeout}
        />
      }
    </>
  );
};

export default AddTicket;
